import type { ShowcaseReviewsConfigDto } from '@repo/api/web/models'

/**
 * Настройки отзывов витрины (`GET reviews/config`). Грузятся один раз на SSR плагином
 * reviewsConfigLoader и переезжают на клиент через payload. null — не загрузились:
 * модуль считаем выключенным.
 */
export const useReviewsConfig = () =>
  useState<ShowcaseReviewsConfigDto | null>('reviews:config', () => null)

/** Включены ли отзывы на витрине: от этого зависят рейтинг, блок отзывов и «Мои отзывы». */
export const useReviewsEnabled = () => {
  const config = useReviewsConfig()
  return computed(() => config.value?.enabled === true)
}
